import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const MpDesign = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){
        $(this.$el).find('.js-designing-item').mouseenter(function () {
            if (!$(this).hasClass('is-active')) {
              $('.js-designing-item').removeClass('is-active');
              $(this).addClass('is-active');
            }
          });
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="section">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Проектирование
                </h2>
            </div>
        </div>
        <div class="designing">

            <div v-for="item in this.struct[this.structKey].componentData.ITEMS" :key="item.ID" class="designing__item js-designing-item" :class="{'is-active': item.ACTIVE}">
                <div class="designing__item-bg" :class="{'no-photo': item.PICTURE == false}">
                    <picture v-if="item.PICTURE !== false">
                        <source :srcset="item.PICTURE" media="(max-width: 768px)">
                        <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME">
                    </picture>
                    <picture v-else>
                        <img :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                    </picture>
                </div>
                <div class="designing__item-top">
                    <a :href="item.LINK" class="designing__item-title">
                        {{item.NAME}}
                    </a>
                    <div class="designing__item-subtitle">
                        {{item.TEXT}}
                    </div>
                </div>
                <div class="designing__item-actions">
                    <a href="#" data-toggle="modal" data-target="#order" class="btn btn--green">Оставить заявку </a>
                    <!-- SAIT-19: калькулятор временно отключён; ссылка сохранена для возможного возврата.
                    <a :href="item.LINK + '#calc'" class="btn btn--beg">
                        <svg class="ico ico-calc" width="20" height="20" aria-hidden="true"><use xlink:href="#ico-calc"></use></svg>
                        Калькулятор
                    </a>
                    -->
                </div>
            </div>
        </div>
    </div>
</section>
    `
}